<form [formGroup]="form" class="style-form">
  <div class="divSelector">
    <p class="inputRadio">Procedencia de Fraude</p>
    <mat-radio-group
      class="checleft"
      [(ngModel)]="procede"
      formControlName="procedencia"
      aria-label="Select an option"
    >
      <mat-radio-button
        (click)="changeValidators('Procedencia')"
        value="Procedencia"
        >Procedencia</mat-radio-button
      >
      <mat-radio-button
        (click)="changeValidators('No Procedencia')"
        style="margin-left: 10px"
        value="No Procedencia"
        >No Procedencia</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class="divisor" *ngIf="form.value.procedencia == 'Procedencia'"></div>
  <div class="divSelector" *ngIf="form.value.procedencia == 'Procedencia'">
    <p class="inputRadio">Hubo Fraude</p>
    <mat-radio-group
      class="checleft"
      formControlName="fraude"
      aria-label="Select an option"
    >
      <mat-radio-button value="Hubo Fraude">Hubo Fraude</mat-radio-button>
      <mat-radio-button style="margin-left: 10px" value="No Hubo Fraude"
        >No Hubo Fraude</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <!-- <div class="divisor" *ngIf="form.value.procedencia=='Procedencia'"></div>
  <div class="divSelector" *ngIf="form.value.procedencia=='Procedencia'">
    <p class="inputRadio">Requiere doble aprobación</p>
    <mat-radio-group class="checleft " formControlName="doble" aria-label="Select an option">
        <mat-radio-button value="Si">Si</mat-radio-button>
        <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
      </mat-radio-group>
  </div> -->
</form>
